import React, {useEffect, useState} from 'react';
import {Button} from 'reactstrap';
import Swiper from "../Components/Swiper";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import axios from "../Config/axios";

function News() {
    const [isMobile, setIsMobile] = useState(false);
    const [news, setNews] = useState([]);
    useEffect(() => {
        axios
            .get("news/get")
            .then((res) => {
                let {code} = res.data;
                if (code === 200) {
                    setNews(res?.data?.data?.news);
                } else if (code === 400) {
                    setNews(res?.data?.data?.news);
                }
            })
            .catch(() => {
            });
    }, []);
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.outerWidth <= 768);
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return (
        <div className={`background ${isMobile ? 'header-placement' : ''}`}>
            {!isMobile && <Swiper/>}
            <Navbar activeLink='news'/>
            <div className='wrapper mt-5'>
                {news.map((el, i) =>
                    <div key={i} className={'news-item-wrapper'}>
                        {!isMobile && <a href={`/news/${el.id}`} className={'news-image-wrapper'}>
                            <img
                                src={el.image_url}
                                alt="" className={'news-item-image'}/>
                        </a>}

                        <div className='news-right'>
                            <a href={`/news/${el.id}`}>
                                <div className={'news-item-title'}>
                                    {el.title}
                                </div>
                            </a>
                            {isMobile && <a href={`/news/${el.id}`} className={'news-image-wrapper'}>
                                <img
                                    src={el.image_url}
                                    alt="" className={'news-item-image'}/>
                            </a>}
                            <div className={'news-item-content'}>
                                <div
                                    dangerouslySetInnerHTML={{__html: el.content}}
                                />
                            </div>
                            <div className={'news-item-button-wrapper'}>
                                <a href={`/news/${el.id}`}><Button color="link">
                                    Дэлгэрэнгүй
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                         className="bi bi-arrow-right" viewBox="0 0 16 16">
                                        <path fillRule="evenodd"
                                              d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"/>
                                    </svg></Button></a>

                            </div>
                        </div>
                    </div>
                )}
                <Footer isMobile={isMobile}/>
            </div>
        </div>
    );
}

export default News;
